import termsHtml from "./content/terms.html?raw";
import { LegalPage } from "./LegalPage";
import { LATEST_LEGAL_VERSION } from "./version";
import { Seo } from "@/marketing/Seo";

export function TermsPage() {
  return (
    <>
      <Seo
        title="Terms of Service — Tapelens"
        description="The terms and conditions governing your use of Tapelens."
        path="/legal/terms"
      />
      <LegalPage title="Terms of Service" lastUpdated={LATEST_LEGAL_VERSION} html={termsHtml} />
    </>
  );
}
